// Generated by scripts/build-ui-icons.mjs.
export { Megaphone as default } from "../ui/glyphs-5";
